import { Mutex, withTimeout } from 'async-mutex';

export const REQUEST_COOLDOWN_MS = 10000;

const mutexes = new Map();

const getMutex = (key) => {
    if (!mutexes.has(key)) {
        mutexes.set(key, withTimeout(new Mutex(), REQUEST_COOLDOWN_MS));
    }
    return mutexes.get(key);
};

export const buildRequestMutexKey = (method, identifier) =>
    `${String(method || 'GET').toUpperCase()}:${identifier}`;

export const runWithRequestMutex = async (key, runRequest) => {
    const mutex = getMutex(key);

    if (await mutex.isLocked()) {
        return;
    }

    try {
        await mutex.acquire();
    } catch {
        return;
    }

    let released = false;
    const releaseMutex = () => {
        if (released) {
            return;
        }
        released = true;
        mutex.release();
    };

    return runRequest(releaseMutex);
};